<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col lg="10">
        <b-card>
          <div slot="header">
            {{ this.$route.meta.title }}
            <div class="card-header-actions">
              <!-- <b-button variant="primary mr-1" @click="posting()"
                ><i class="fa fa-upload"></i> Posting</b-button
              > -->
              <!-- <b-button variant="primary mr-1" @click="exportxls()"
                ><i class="fa fa-file-excel-o"></i> Export</b-button
              > -->
            </div>
          </div>
          <b-row>
            <b-col>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Periode Trx.</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.tgl1"
                  type="date"
                  style="min-width: 50px; max-width: 150px"
                ></b-form-input>
                <b-input-group-prepend
                  ><span class="input-group-text"
                    >-</span
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.tgl2"
                  type="date"
                  style="min-width: 50px; max-width: 150px"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Project</label>
                </b-input-group-prepend>
                <b-form-select
                  v-model="tblData.pjxkey"
                  :plain="true"
                  :options="projectsFilt"
                ></b-form-select>
                <b-button class="btn btn-success ml-1" @click="refresh()">
                  <i class="fa fa-refresh"></i> Apply
                </b-button>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                  <i class="fa fa-eraser"></i>Clear
                </b-button>
              </b-input-group>
            </b-col>
          </b-row>
          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive
            striped
            hover
            small
            style="font-size: smaller"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit"
            :busy="isBusy"
            show-empty
          >
            <template v-slot:cell(index)="data">{{
              (tblData.page - 1) * tblData.limit + (data.index + 1)
            }}</template>
            <template v-slot:cell(trxDate)="data">{{
              data.item.trxDate | moment("YYYY MMM DD")
            }}</template>

            <template v-slot:cell(principal)="data">{{
              data.item.principal | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(interest)="data">{{
              data.item.interest | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(taxAmt)="data">{{
              data.item.taxAmt | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(interestAfterTax)="data">{{
              data.item.interestAfterTax | numFormat("0,0.00")
            }}</template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(empty)="data">
              <h4>{{ data.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="data">
              <h4>{{ data.emptyFilteredText }}</h4>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="4">
              <div>
                Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
                to
                <span v-if="tblData.page * tblData.limit > tblData.total">{{
                  tblData.total
                }}</span>
                <span v-else>{{ tblData.page * tblData.limit }}</span>
                of {{ tblData.total | numFormat }} entries
              </div>
            </b-col>
            <b-col cols="4">
              <b-form-group
                label-cols="3"
                label
                style="margin-top: 0 !important"
              >
                <b-input-group>
                  <b-input-group-prepend class="mr-2">
                    <label>Limit per page</label>
                  </b-input-group-prepend>
                  <div class="d-flex">
                    <b-form-select
                      :options="[10, 15, 20, 25]"
                      :plain="true"
                      v-model="tblData.limit"
                      size="sm"
                      style="width: 80px"
                    />
                  </div>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              >
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      projectsFilt: [
        {
          value: "",
          text: "-- ALL --",
        },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tablename: "withdraw-summary",
        sortBy: "trxDate",
        sortDesc: true,
        customQuery:"",
        tgl1: moment().startOf("M").format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        pjxkey: "",
        pjxName:"",
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "trxDate",
          label: "Trx Date",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "principal",
          label: "Principal",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "interest",
          label: "Interest",
          thClass: "text-center",
          tdClass: "text-right",
          tdStyle: "margin-right:10px",
          sortable: true,
        },
        {
          key: "interestAfterTax",
          label: "Interest After Tax",
          thClass: "text-center",
          tdClass: "text-right",
          tdStyle: "margin-right:10px",
          sortable: true,
        },
        {
          key: "taxAmt",
          label: "Tax Amt",
          thClass: "text-center",
          tdClass: "text-right",
          tdStyle: "margin-right:10px",
          sortable: true,
        },
        {
          key: "taxBukuNo",
          label: "Jurnal No.",
          thClass: "text-center",
          tdClass: "text-right",
          tdStyle: "margin-right:10px",
          sortable: true,
        },
      ];
      return fields;
    },
  },
  async created() {
    const [projects] = await Promise.all([
      crud.list({
        tablename: "project",
        page: 1,
        limit: 10000,
        total: 0,
        sortBy: "pjxname",
        sortDesc: false,
      }),
    ]);

    projects.forEach((tp) => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname });
    });
  },
  methods: {
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter[this.$route.name]) {
          this.tblData[key] = filter[this.$route.name][key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter[this.$route.name];
          this.$store.commit("filter", filter);
        }

        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || "") == "") {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }
        let str ="";
        if((this.tblData.tgl1!="") || (this.tblData.tgl2!="")){
          str += str ? "&" : "?";
          str = `trxDate=between '${encodeURIComponent(this.tblData.tgl1)}' and '${encodeURIComponent(this.tblData.tgl2)}'`;
        }

        if((this.tblData.pjxkey!="")){
          str += str ? "&" : "?";
          str += `pjxkey=${encodeURIComponent(this.tblData.pjxkey)}`;
        }

        this.tblData.customQuery =str;

        console.log('this.tblData.customQuery',this.tblData.customQuery)

        const list = await crud.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await disbursement.exportreportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.pjxkey = "";
      this.tblData.pjxName = "";
      this.refresh();
    },
    saveFilter() {
      let filtered = false;
      const filterObj = {};
      for (const key in this.tblData) {
        filterObj[key] = this.tblData[key];
        filtered = true;
      }
      if (filtered === true) {
        const filter = this.$store.state.filter;
        filter[this.$route.name] = filterObj;
        this.$store.commit("filter", filter);
      }
    },
    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>